module.exports = __webpack_public_path__ + "img/blueEdit.02198567.svg";